<template>
  <b-modal v-click-outside="hideDownloadMenu" size="lg" class="b_modal_custom" @hidden="onHideModal" v-model="stateOpenModal" hide-header hide-footer scrollable :no-close-on-backdrop="clickTimeout">
    <div @click="hideDownloadMenu" :id="downloadId" class="body-p">
      <div class="b_modal_custom-header">
        <header class="header" v-if="titleModal || subtitleModal">
          <div class="header_wrap">
            <h3 class="title_modal" v-if="titleModal">
              {{ titleModal }}
              <span v-if="specificSiteId.length > 0 && !tDateShow"> {{ "_" + getSiteID(this.specificSiteId[0]) }}</span>
            </h3>
            <div v-if="showCloseIcon && tDateShow" class="pointer" @click="onHideModal">
              <span>X</span>
            </div>
          </div>
          <h5 class="subtitle_modal" v-if="subtitleModal">
            {{ subtitleModal }}
          </h5>
        </header>
      </div>
      <div class="b_modal_custom-body" v-click-outside="hideDownloadMenu">
        <b-table v-if="itemsTable && itemsTable.length > 0" small responsive :items="items" :fields="fieldsTable">
          <template :slot="initNameFields" slot-scope="row">
            <div>
              <span>{{ row.value }}</span>
              <div class="custom-tooltip table-tooltip">
                <div>{{ row.value }}</div>
              </div>
            </div>
          </template>

          <template :slot="initValueFields" slot-scope="row">
            <span v-if="Number(row.value) > -1">{{ Math.round(row.value) }}%</span>
            <span v-else>-</span>
          </template>
        </b-table>
        <div v-else class="align-center p-60">
          <div class="card-text-title no-data" v-if="dataLoaded">
            No Data In
          </div>
        </div>
        <div class="col-xl-12 color_slate-grey pt-15" v-bind:class="{ presets: tDateShow }">
          {{ todayDate }}
        </div>
      </div>
    </div>

    <div class="b_modal_custom_footer mt-2" v-click-outside="hideDownloadMenu">
      <span class="pr-10" v-click-outside="hideDownloadMenu">
        <img src="static/img/download-graphs.png" class="download_graph_icon cursor_pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Download" @click="handleClickOpen" v-if="itemsTable && itemsTable.length > 0" />
        <div v-show="dropdownOpen" id="custom-dropdown-menu-skinny" class="custom-dropdown-menu-class download-dropdown-box p-0">
          <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadAsCsv"> <img src="/static/img/csv.svg" class="mr-6" />CSV </span>
          <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadAsPdf(downloadId)"> <img src="/static/img/pdf.svg" class="mr-6" />PDF </span>
          <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadAsPng(downloadId)"> <img src="/static/img/img.svg" class="mr-6" />PNG </span>
        </div>
      </span>
    </div>
  </b-modal>
</template>
<script>
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import _ from "lodash";
import ClickOutside from "vue-click-outside";
import { downloadCSV, getSiteID } from "../../../services/visualization/data-management";

export default {
  props: {
    openModal: { type: Boolean, default: false },
    titleModal: { type: String, default: "" },
    downloadId: { type: String, default: "" },
    subtitleModal: { type: String, default: "" },
    dataSources: [Array, null],
    listSortedFields: [Array, null],
    listSortedMethods: [Array, null],
    showCloseIcon: { type: Boolean, default: false },
    fieldsTable: [Array, null],
    itemsTable: [Array, null],
    initNameFields: { type: String, default: "" },
    initValueFields: { type: String, default: "" },
    specificSiteId: [Object, Array],
    dataLoaded: { type: Boolean, default: false }
  },

  data() {
    return {
      stateOpenModal: this.openModal,
      items: [Array, null],
      dropdownOpen: false,
      todayDate: "",
      tDateShow: true,
      hideOnDownload: false,
      getSiteID,
      clickTimeout: true
    };
  },

  watch: {
    openModal: function(open) {
      this.stateOpenModal = open;
      if (open) {
        setTimeout(() => {
          this.clickTimeout = false;
        }, 1000);
      }
    },

    itemsTable: function(newValue) {
      const isFilterFieldsEmpty = _.isEmpty(this.listSortedFields);
      const isFilterMethodsEmpty = _.isEmpty(this.listSortedMethods);

      if (Array.isArray(newValue) && newValue.length > 0) {
        if (!isFilterFieldsEmpty) {
          const orderMethods = isFilterMethodsEmpty ? this.listSortedFields.map(() => "asc") : this.listSortedMethods;

          let filteredFields = [];

          if (this.listSortedFields[2] && this.listSortedFields[2] === "threadId") {
            filteredFields = [this.listSortedFields[0], d => _.toLower(d[this.initNameFields]), d => _.toLower(d["threadId"])];
          } else {
            filteredFields = [this.listSortedFields[0], d => _.toLower(d[this.initNameFields])];
          }

          this.items = _.orderBy(newValue, filteredFields, orderMethods);
        }
      } else {
        this.items = newValue;
      }
    }
  },
  methods: {
    onHideModal() {
      this.$emit("onHideModal", false);
      this.clickTimeout = true;
    },

    handleClickOpen() {
      if (!this.clickTimeout) {
        this.dropdownOpen = !this.dropdownOpen;
      }
    },

    hideDownloadMenu() {
      this.dropdownOpen = false;
      this.clickTimeout = true;
    },

    downloadAsCsv() {
      this.dropdownOpen = false;

      const csvContent = [];
      let headerCsv = [];
      headerCsv = this.fieldsTable.map(ft => ft.label);
      headerCsv[headerCsv.length - 1] = headerCsv[headerCsv.length - 1] + "(%)";

      //   const copyData = _.orderBy(this.itemsTable, [this.initValueFields, (d) => d.activityName.toLowerCase()], ["desc", "asc"])

      this.items.map(t => {
        const rowContent = [];
        this.fieldsTable.forEach(field => {
          const valForValue = t[field.key];
          rowContent.push(valForValue);
        });
        csvContent.push(rowContent);
      });

      // csvContent = _.orderBy(Array.from(csvContent), [
      //   (csv) => Number(csv[csv.length - 1]),
      // ]);
      downloadCSV(this.titleModal, headerCsv, csvContent, this.specificSiteId);
    },

    downloadAsPdf(downloadId) {
      this.dropdownOpen = false;
      this.hideOnDownload = true;
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        let filename = this.titleModal + "_" + this.todayDate + ".pdf";
        if (this.specificSiteId && this.specificSiteId.length > 0) {
          filename = this.titleModal + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".pdf";
        }
        const container = document.querySelector("#" + downloadId);

        this.tDateShow = true;

        html2canvas(container, {
          allowTaint: true,
          scrollY: 0,
          scrollX: 0,
          onclone: function(document) {
            const elementClone = document.getElementById(downloadId);
            if (elementClone) {
              // elementClone.style.padding = '20px';
            } else {
              return;
            }
            // document.querySelectorAll('.nav-item').forEach(element=>{
            //     const ele = element.querySelector('.nav-link.active');
            //     if (!ele) {
            //         element.remove();
            //     }
            // })
          }
        }).then(canvas => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jspdf("p", "mm", "a4");

          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
          pdf.save(filename);

          this.hideOnDownload = false;
        });
      }, 1);
    },

    downloadAsPng(downloadId) {
      this.dropdownOpen = false;
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        const container = document.querySelector("#" + downloadId);
        let filename = this.titleModal + "_" + this.todayDate + ".png";
        if (this.specificSiteId && this.specificSiteId.length > 0) {
          filename = this.titleModal + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".png";
        }

        this.tDateShow = true;

        html2canvas(container, {
          allowTaint: true,
          scrollY: 0,
          scrollX: 0,
          onclone: function(document) {
            document.querySelectorAll(".nav-item").forEach(element => {
              const ele = element.querySelector(".nav-link.active");
              if (!ele) {
                element.remove();
              }
            });
          }
        }).then(canvas => {
          const link = document.createElement("a");
          document.body.appendChild(link);

          link.download = filename;
          link.href = canvas.toDataURL("image/png");
          link.target = "_blank";
          link.click();
        });
      }, 1);
    }
  },

  directives: {
    ClickOutside
  }
};
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.body-p {
  padding: 6px;
}
</style>
